import React from 'react';
import Modal from 'react-bootstrap/Modal';
import DateTH from '../../../Helper/date-th';

function ModalsHistory({ modalHis, setModalHis, historyData }) {
  return (
    <>
      <Modal
        show={modalHis}
        onHide={() => {
          setModalHis(false);
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>ประวัติการสแกน</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: '15px' }}>
          <div style={{ overflow: 'auto' }}>
            <table className="table table-bordered">
              <thead style={{ backgroundColor: '#3f75c1' }}>
                <tr style={{ color: '#FFFFFF' }}>
                  <td style={{ width: '10%' }}>รหัสพนักงานขนส่ง</td>
                  <td style={{ width: '10%' }}>ชื่อพนักงานขนส่ง</td>
                  <td style={{ width: '10%' }}>ศูนย์กระจายสินค้า</td>
                  <td style={{ width: '10%' }}>สถานะ</td>
                  <td style={{ width: '15%' }}>วันที่/เวลาที่สแกน</td>
                </tr>
              </thead>
              <tbody>
                {historyData.map((value, index) => (
                  <tr key={index + 'Key' + value.AWB_CODE}>
                    <td>{value.Staff_code}</td>
                    <td>{value.name}</td>
                    <td>{value.hub}</td>
                    <td>{value.shipment_name}</td>
                    <td>
                      <DateTH date={value.Receiver_Date + ' ' + value.Receiver_Time} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {historyData.length === 0 ? <div style={{ color: 'red', textAlign: 'center', padding: '50px' }}>ไม่พบข้อมูล</div> : ''}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalsHistory;
